import { COLORS } from "~/data/ui/colors";

const useStyles = () => ({
  container: {
    position: 'relative',
  },
  dotsContainer: {
    display: 'flex',
    justifyContent: 'end',
    position: 'absolute',
    left: '24px',
    bottom: '12px',
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    margin: '0 4px',
    transition: 'background-color 0.3s ease-in-out',
  },
  activeDot: {
    backgroundColor: COLORS.yellow.main,
  },
  inactiveDot: {
    backgroundColor: COLORS.gray.dark8,
  },
});

export default useStyles;
